import { FunctionComponent } from 'react';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageAboutSectionCooperation: FunctionComponent<Props> = ({
    translations: {
        title,
        imageUrl,
    },
}) => {
    return (
        <StyledComponent
            className="public-page-about-section-cooperation"
        >
            <div
                className="title"
                dangerouslySetInnerHTML={{ __html: title }}
            />
            <img
                className="image"
                src={imageUrl}
                loading="lazy"
            />
        </StyledComponent>
    );
};

export default PublicPageAboutSectionCooperation;